import { ReadScreen } from '@/screens/read-screen/ReadScreen'

export default function () {
  return <ReadScreen />
}
